import { usePositionBrokers } from "@/src/hooks/usePositionBrokers";

export const usePlaidBrokers = (
  type: "INVEST" | "BANKING",
  options?: { enabled?: boolean },
) => {
  return usePositionBrokers({
    channel: "plaid",
    institutionType: type,
    enabled: options?.enabled,
  });
};
